(function () {
  'use strict';

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueId(base, used) {
    var id = base || 'section';
    var i = 2;
    while (used.has(id)) {
      id = base + '-' + i;
      i++;
    }
    used.add(id);
    return id;
  }

  function init() {
    var body = document.querySelector('[data-sleephub-article-body]');
    var toc = document.querySelector('[data-sleephub-toc]');
    if (!body) return;

    var headings = body.querySelectorAll('h2, h3');
    var used = new Set();

    headings.forEach(function (h) {
      if (!h.id) {
        h.id = uniqueId(slugify(h.textContent), used);
      } else {
        used.add(h.id);
      }
      if (!h.querySelector('.sleephub-anchor-link')) {
        var a = document.createElement('a');
        a.className = 'sleephub-anchor-link';
        a.href = '#' + h.id;
        a.setAttribute('aria-label', 'Link to ' + h.textContent.trim());
        a.textContent = '#';
        h.appendChild(a);
      }
    });

    if (!toc) return;
    var list = toc.querySelector('[data-sleephub-toc-list]');
    var h2s = body.querySelectorAll('h2');
    if (!list || h2s.length === 0) {
      toc.hidden = true;
      return;
    }

    var lookup = {};
    h2s.forEach(function (h2) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = h2.textContent.replace(/#$/, '').trim();
      a.dataset.tocFor = h2.id;
      li.appendChild(a);
      list.appendChild(li);
      lookup[h2.id] = a;
    });

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        if (!lookup[id]) return;
        if (entry.isIntersecting) {
          Object.keys(lookup).forEach(function (key) {
            lookup[key].classList.toggle('is-active', key === id);
          });
        }
      });
    }, {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    });

    h2s.forEach(function (h2) { io.observe(h2); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
